import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { SearchPatternsParams } from '@/entities/pattern';

import type { PatternFilterSchema } from '../types/pattern-filter.schema';

const initialState: PatternFilterSchema = {
    filters: {},
};

// TODO: Merge with patternSlice ?
export const patternFilterSlice = createSlice({
    name: 'patternFilter',
    initialState,
    reducers: {
        setFilterValues: (
            state,
            action: PayloadAction<Partial<SearchPatternsParams>>,
        ) => {
            const { payload } = action;

            // Ensure Timeframe is stored as an array
            if (payload.Timeframe && !Array.isArray(payload.Timeframe)) {
                payload.Timeframe = [payload.Timeframe];
            }

            state.filters = payload as SearchPatternsParams;
        },
        updateFilterValues: (
            state,
            action: PayloadAction<Partial<SearchPatternsParams>>,
        ) => {
            const { payload } = action;

            // Ensure Timeframe is stored as an array
            if (payload.Timeframe && !Array.isArray(payload.Timeframe)) {
                payload.Timeframe = [payload.Timeframe];
            }

            // Merge existing filters with new payload values first
            const mergedFilters: Record<string, unknown> = {
                ...state.filters,
                ...payload,
            };

            // Remove any key where the incoming value is `null`, `undefined`,
            // or an empty array – this allows callers to effectively delete
            // a filter by setting it to null.
            Object.entries(payload).forEach(([key, value]) => {
                const shouldDelete =
                    value === null ||
                    value === undefined ||
                    (Array.isArray(value) && value.length === 0);

                if (shouldDelete) {
                    delete mergedFilters[key];
                }
            });

            state.filters = mergedFilters as SearchPatternsParams;
        },
        clearFilter: () => initialState,
    },
});

export const { setFilterValues, updateFilterValues, clearFilter } =
    patternFilterSlice.actions;

export const patternFilterReducer = patternFilterSlice.reducer;
